<template>
  <metainfo>
  </metainfo>
  <div
    class="global_page"
    :class="[pageClassGlobal, $store.getters.getAccountType]"
  >
    <div class="page_wrapper" :class="mainMenu ? 'with_main_menu' : ''">
      <div v-if="emulateMode" class="emulateMode">
        <div class="emulateMode_content">Please be aware. You are logged in as a real user so the changes you make will affect user's data.</div>
        <div v-if="clinicName" class="emulateMode_title">{{ clinicName }}</div>
      </div>
      <div
        class="emulate-wrapper"
        :class="emulateMode ? 'emulate-padding' : ''"
      >
        <router-view :key="$route.fullPath + state"></router-view>

      
      </div>
      <the-main-menu v-if="mainMenu"></the-main-menu>
    </div>
  </div>
</template>

<style lang="scss">
@import "~@/assets/styles/app";
</style>

<script>
import pSBC from "@/components/pSBC/pSBC";

import {
  useMeta,
} from "vue-meta";

import { computed, ref  } from "vue";

import { isUSRegion } from '@/helpers/region/regionHelper.js';
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';
import { setGAUser, resetGAUser } from '@/helpers/analytics/ga.js';

"@ionic/vue";

import { TheMainMenu } from "@/components/components";

const appHeight = () => {
  $(".page_wrapper").css("--app-height", `${window.innerHeight}px`);
};

$(document).ready(function () {
  window.addEventListener("resize", appHeight);
  appHeight();
});

export default {
  components: {

    TheMainMenu,
  },
 
  data() {
    return {
      fullscreenLoading: true,
      requestsCount: 0,
      state: 1,

      pageClassGlobal: this.initPageClassGlobal(
        this.$router.currentRoute.value
      ),
      mainMenu: false,
      accountType: this.$store.getters.getAccountType,
      loggedIn: this.$store.getters.getLoggedStatus,
      emulateMode: window.localStorage.getItem("emulate"),
      isAustralia : isAustraliaRegion(),
      isUS : isUSRegion(),
      pendoInitializedVisitorId: null,
    };
  },
  computed: {
    clinicName() {
      const userData = this.$store.getters.GET_USER_DATA;
      return userData?.id && userData?.name ? userData.name : "";
    },
  },
  setup() {
    const checkRegionAus = ref(isAustraliaRegion()); 
    const pageText = {
      title: checkRegionAus.value ? "Locumate" : "HealthShifts",
      description: "Description",
    };
    const computedMeta = computed(() => ({
      title: pageText.title,
      description: pageText.description,
    }));
    useMeta(computedMeta);   
  },
  provide() {
    return {
      setPageClassGlobal: this.setPageClassGlobal,
      mainMenuShow: this.mainMenuShow,
      routerViewState: () => this.state++,
    };
  },
  methods: {
    isPendoEnabled() {
      const raw = process.env.VUE_APP_PENDO_ENABLED;

      console.log('raw', raw);
      

      if (raw === undefined || raw === null || raw === "") return true;

      const normalized = String(raw).trim().toLowerCase();
      return !["false", "0", "no", "off"].includes(normalized);
    },
    pendoInitializeIfReady() {
      try {
        if (!this.isPendoEnabled()) return;
        
        const token = this.$store.getters.GET_TOKEN;
        const user = this.$store.getters.GET_USER_DATA;
        const visitorId = user && user.id ? user.id : null;

        console.log('helklo');
        

        // Initialize only for authenticated users with real user data.
        if (!token || !visitorId) return;

        // Avoid repeated initialize calls for same visitor.
        if (this.pendoInitializedVisitorId === visitorId) return;

        const visitor = {
          id: String(visitorId),
        };

        if (user.email) visitor.email = String(user.email);
        if (user.firstName) visitor.firstName = String(user.firstName);
        if (user.lastName) visitor.lastName = String(user.lastName);
        if (user.role) visitor.role = String(user.role);

       const isLocum = user.role?.toLowerCase() === "locum";
       const account = isLocum
        ? {
            id: "locumate-locum-pool",
            name: "Locum Pool",
          }
        : {
            id: user.id,
            name: user.firstName
              ? `${user.firstName} ${user.lastName || ""}`
              : "Unknown",
          };
       

        if (window.pendo && typeof window.pendo.initialize === "function") {
          window.pendo.initialize({ visitor, account });
          this.pendoInitializedVisitorId = visitorId;

          console.log('visitor', visitor);
          console.log('account', account);
        }
      } catch (e) {
        // Never break app flow because of analytics.
        console.warn("Pendo initialize failed", e);
      }
    },
    pendoReset() {
      this.pendoInitializedVisitorId = null;
    },
    showLoading() {
      this.fullscreenLoading = this.$loading({
        lock: true,
        background: "rgba(0, 0, 0, 0.85)",
      });
    },
    initPageClassGlobal(page) {
      let classNameArray = [];
      const divider = "_";
      const prefix = "global" + divider;
      const suffix = divider + "page";

      if (this.$route.matched.length > 1 && this.$route.matched[0].name) {
        classNameArray.push(this.$route.matched[0].name);
      }
      if (page.name) {
        classNameArray.push(page.name);
      } else {
        classNameArray.push(page.path.replaceAll("/", divider));
      }

      if (this.$route.params.page) {
        classNameArray.push(
          classNameArray[classNameArray.length - 1] +
            divider +
            this.$route.params.page
        );
      }
      let className = classNameArray.map((i) => prefix + i + suffix).join(" ");

      return className;
    },
    setPageClassGlobal(className) {
      if (this.pageClassGlobal.indexOf(className) == -1) {
        this.pageClassGlobal += " " + className;
      }
    },

    mainMenuShow(status) {
      this.mainMenu = status;
    },
    pusherSetToken() {
      const token = this.$store.getters.GET_TOKEN;
      const userId = this.$store.getters.GET_USER_DATA.id;

      if (token) {
        this.pusher.setToken(token, "app");
        this.pusher.pusherChatSubscribe("counters_" + userId);
        this.pusher.pusherNotificationsSubscribe(userId);
        this.pusher.pusherBind();
        (async () => {
          try {
            await this.$store.dispatch("GET_NOTIFICATIONS_MESSAGES", {
              params: {
                hideLoading: true,
              },
            });

          } catch (error) {
            console.log(error);
          }
        })();
      } else {
        console.log("Token is not ready yet");
      }
    },
    setWhiteLabel() {
      const userData = this.$store.getters.GET_USER_DATA;
      let primaryColor ="";

      if(this.isAustralia){
        primaryColor = "11, 53, 154";
      }
      if(this.isUS){
        primaryColor = "0, 56, 101";
      }

      if (userData.whiteLabel && userData.whiteLabel.primaryColor) {
        primaryColor = userData.whiteLabel.primaryColor;
      }
      let secondaryColor = pSBC(-0.5, "rgb(" + primaryColor + ")");

      document.body.style.setProperty("--locumate-primary-color", primaryColor);
      document.body.style.setProperty("--locumate-primary-color-dark", primaryColor);

      document.body.style.setProperty(
        "--locumate-primary-color-hover",
        secondaryColor
      );
      document.body.style.setProperty(
        "--locumate-primary-color-disabled",
        pSBC(-0.3, "rgb(" + primaryColor + ")", "#fff")
      );
    },
  },
  async created() {
    console.log("I am created");
    try {
        const token = this.$store.getters.GET_TOKEN;
        console.log("🚀 ~ file: App.vue:182 ~ created ~ token:", token);


        if (this.$pusher && typeof this.$pusher.setToken === 'function') {
          await this.pusher.setToken(token, "created");
        
        console.log('Token:', token);

        this.unsubscribe = this.$store.subscribeAction({
          after: (action) => {
            if (action.type == "setAccountType") {
              this.accountType = this.$store.getters.getAccountType;
            }
            if (action.type == "AUTH_LOGOUT") {
              // this.$router.go(0);
              this.pendoReset();
              resetGAUser();
            }
            if (action.type == "AUTH_SUCCESS") {
              this.pusherSetToken();
              this.setWhiteLabel();
              this.pendoInitializeIfReady();
              const authUser = this.$store.getters.GET_USER_DATA;
              if (authUser && authUser.id) setGAUser(authUser.id, authUser.role);
            }
            if (action.type == "SET_CURRENT_USER_DATA") {
              this.setWhiteLabel();
              this.pendoInitializeIfReady();
              const currentUser = this.$store.getters.GET_USER_DATA;
              if (currentUser && currentUser.id) setGAUser(currentUser.id, currentUser.role);
            }
          },
        });

        this.setWhiteLabel();
        this.pendoInitializeIfReady();

        // ... (rest of your logic)
      } else {
        console.error('Error: $pusher or setToken method is not properly initialized.');
      }

        // Assuming this.pusher.setToken is an asynchronous operation
        
      } catch (error) {
        console.error('Error initializing app:', error);
      }
    this.setWhiteLabel();
    this.pendoInitializeIfReady();
    const startupUser = this.$store.getters.GET_USER_DATA;
    if (startupUser && startupUser.id) setGAUser(startupUser.id, startupUser.role);
    console.log('axios instance:', this.axios);
    this.axios.interceptors.request.use((req) => {
      console.log("🚀 ~ file: App.vue:221 ~ this.axios.interceptors.request.use ~ req:", req.url)
      if (
        (req.params && req.params.hideLoading) ||
        (req.data && req.data.hideLoading)
      ) {
        req.params
          ? delete req.params.hideLoading
          : delete req.data.hideLoading;
      } else {
        console.log("🚀 ~ XXXXXX", req.url.includes('job-seeker'))
        if(req.url !== 'search' && req.url !== 'job-seeker/job-post' && req.url !=='job-seeker/job-post-applications' && req.url !== '/job-seeker/previous/job-post-applications' && req.url !== 'job-board/job-post' && req.url !== 'job-board/previous/job-post' && req.url !== 'job-board/applicants' && req.url !== 'job-board/job-post-attributes' && req.url !== 'job-board/applicant-status' ){
          if (this.requestsCount == 0) {
            this.showLoading();
          }
          this.requestsCount++;
        }else{
          console.log("🚀 ~ YYYYYYY", req.url)
          req.params
          ? delete req.params.hideLoading
          : delete req.data.hideLoading;
        }
      }

      return req;
    });
   

    this.axios.interceptors.response.use(
      (resp) => {
        if (this.requestsCount == 1) {
          this.fullscreenLoading.close();
        }
        if (this.requestsCount >= 1) {
          this.requestsCount--;
        }

        return resp;
      },
      (error) => {

        if (this.requestsCount == 1) {
          this.fullscreenLoading.close();
        }
        if (this.requestsCount >= 1) {
          this.requestsCount--;
        }

        if (
          error.response &&
          error.response.data &&
          (error.response.data.pendingDocuments || error.response.data.pending_documents)
        ) {
          return Promise.reject(error);
        }

        let errorMessage = null;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          errorMessage = error.response.data.message;
        } else {
          if (Array.isArray(error.response.data.errors)) {
            error.response.data.errors.forEach((item) => {
              errorMessage = item.message;
            });
          } else {
            errorMessage = error.response.data.errors;
          }
          if (errorMessage.num_of_tech) {
            errorMessage = error.response.data.errors.num_of_tech[0];
          }
          if (errorMessage.phone) {
            errorMessage = error.response.data.errors.phone[0];
          }
        }

        if (errorMessage) {
          console.log(errorMessage);
          if (
            error.response.status === 403 &&
            errorMessage === "Access denied"
          ) {
            console.log(errorMessage);
          } else if(error.response.status === 400) {
            if (typeof errorMessage === "object") {
              let message = "";
              for (const key in errorMessage) {
                if (Object.prototype.hasOwnProperty.call(errorMessage, key)) {
                  const element = errorMessage[key];
                  message += element + "<br>";
                }
              }

              errorMessage = message;
            }
            this.$notify({
              dangerouslyUseHTMLString: true,
              title: "Error",
              message: errorMessage,
              type: "error",
              duration: 10000,
            });
          } else {
            this.$notify({
              title: "Error",
              message: errorMessage,
              type: "error",
              duration: 10000,
            });
          }
        }

        if (error.response.status === 401) {
          this.$router.push({
            name: "home",
          });
        }

        if (error.response.status === 503) {
          if (this.$router.currentRoute.value.name !== 'maintenance_mode') {
            this.$router.push({
              name: "maintenance_mode",
            });
          } else {
            return;
          }
        }
        throw error;
      }
    );
  },

  mounted() {
    appHeight();
    this.pusherSetToken();
    
    const associationId =
      this.$route.query.associationId ||
      (this.$route.redirectedFrom && this.$route.redirectedFrom.query.associationId);

    const prevAssociationId = localStorage.getItem('association_id');
    
    if (associationId && associationId !== prevAssociationId) {
      localStorage.setItem('association_id', associationId);
    }

  },

  beforeUnmount() {
    this.unsubscribe();
  },
  watch: {
    $route(to) {
      this.mainMenuShow(false);
      this.pageClassGlobal = this.initPageClassGlobal(to);
      window.scrollTo(0, 0);
    },
  },
};
</script>

